import {connect} from 'react-redux'

import {chatSend} from './chat.action'
import {activateLegByHashtag} from '../leg/leg.action'
import {ChatSidebar} from './chatsidebar.component'
import {routerLoadHashtag} from '../services/router/router.action'
import userUtil from '../util/user.util'


const mapStateToProps = (state) => {
    return {
        chat: state.get('chat'),
        currentUser: userUtil.getCurrentUser(state),
        legs: state.getIn(['document', 'legs']),
        tripName: state.getIn(['document', 'properties', 'tripTitle']),
        tripGuid: state.getIn(['document', 'properties', 'tripGuid']),
        travelers: state.getIn(['document', 'travelers']),
        uistate: state.get('uiState')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChatSend: (trip_id, message, sender_user_id, hashtag, mentions, created_at) => {
            dispatch(chatSend(trip_id, message, sender_user_id, hashtag, mentions, created_at))
        },
        onLoadHashtag: (path) => {
            dispatch(routerLoadHashtag(path))
        }
    }
}

const ChatSidebarContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ChatSidebar)

export default ChatSidebarContainer
